<template>
    <div class="news">
        <h2 class="text-center text-md-start mb-3">News</h2>
        <BRow class="m-0 p-0" v-if="!newsCardsData?.length">
            <BCol lg="12" class="news__block">
                <BRow>
                    <BCol cols="12" class="p-2 p-lg-3 bg-white rounded w-full px-3">
                        There's no news to display right now!
                    </BCol>
                </BRow>
            </BCol>
        </BRow>

        <div class="news-grid">
            <div class="news-grid-wrapper" v-for="(newsCard, index) in newsCardsData"
                :key="index" @click="handleSelectedNews(newsCard)">
                <NewsCards class="news-card h-100" :newsBtnText="newsCard.extra"
                    :newsImage="`${this.baseUrl}${newsCard.imageFile}`" :newsText="newsCard.name" />
            </div>
        </div>

        <b-modal v-model="openModal" size="lg" hide-header hide-footer no-fade class="winnerAward-modal"
            :centered="true">
            <img src="../assets/svgs/close.svg" class="close__img cursor-pointer" @click="openModal = false" />
            <div class="mt-3">
                <div>
                    <div>
                        <ImageWithFallback :src="selectedNews?.imageFile" class="object-fit-cover h-100 comunityCard__img" />
                        <div class="d-flex align-items-center" v-if="$route.name == 'sponsors'">
                            <ImageWithFallback :src="selectedNews.imageFile" class="comunityCard__logo" />
                            <p class="mb-0 sponsor__card__imgBox-text">
                                {{ selectedNews?.name }}
                            </p>
                        </div>
                    </div>
                    <BCardTitle class="font-weight-bold comunityCard__title mt-3">{{ selectedNews?.name }}</BCardTitle>
                    <BCardText class="comunityCard__description mb-2">
                        {{ selectedNews?.extra }}
                    </BCardText>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import NewsCards from "@/components/NewsCards.vue";
import CommunityCard from "@/components/CommunityCard.vue";
import ImageWithFallback from "@/components/ImageWithFallback.vue";

export default {
    components: {
        NewsCards,
        CommunityCard,
        ImageWithFallback,
    },
    data() {
        return {
            newsCardsData: [],
            selectedNews: null,
            openModal: false,
        };
    },
    watch: {
        golfClubData() {
            if (
                this.golfClubData &&
                this.golfClubData.news &&
                this.golfClubData.news.length > 0
            ) {
                this.selectedNews = this.golfClubData.news[0];
                this.newsCardsData = this.golfClubData.news;
            } else {
                this.selectedNews = null;
            }
        },
    },
    methods: {
        handleSelectedNews(newCard) {
            this.selectedNews = newCard;
            this.openModal = true;
        },
    },

    mounted() {
        if (
            this.golfClubData &&
            this.golfClubData.news &&
            this.golfClubData.news.length > 0
        ) {
            this.newsCardsData = this.golfClubData.news;
            this.selectedNews = this.golfClubData?.news[0];
        }
    },
};
</script>

<style lang="scss">
.fixed-comunity-card {
    position: fixed !important;
    width: 400px !important;

    @media screen and (max-width: 1440px) {
        width: 340px !important;
        height: auto !important;
    }

    @media screen and (min-width: 2560px) and (max-width: 5000px) {
        width: 25% !important;
        height: auto !important;
    }
}

.card-modal-img {
    img {
        max-height: 300px;
    }
}

.news-grid {
    display: grid;
    gap: 1rem;
    justify-content: center;

    grid-template-columns: repeat(2, 1fr);

    @media (min-width: 576px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 970px) {
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    }
}

.news-grid-wrapper {
    width: 100%;
    justify-self: center;

    @media (min-width: 575px) {
        aspect-ratio: 1 / 1;
    }
}

</style>
